import { Alert as AlertLibrary } from '@mui/material';
import { cn } from 'cn';
import { type PropsWithChildren, type ReactNode } from 'react';

import { type Severity } from '~/types/severity';

type P = PropsWithChildren<{
  readonly action?: ReactNode;
  readonly Icon?: JSX.Element;
  readonly severity?: Severity;
}> &
  ComponentStyling;

export const Alert = ({
  action,
  children,
  className,
  Icon,
  severity = 'info',
  style,
  variant,
}: P) => {
  return (
    <AlertLibrary
      action={action}
      className={cn(
        '[&_.MuiAlert-message]:w-full [&_.MuiAlert-message]:max-w-none',
        className,
      )}
      icon={Icon}
      severity={severity}
      style={
        style ?? {
          maxWidth: 'none',
          width: '100%',
        }
      }
      variant={variant}
    >
      {children}
    </AlertLibrary>
  );
};
